webpackJsonp([35783957827783],{

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _lodash = __webpack_require__(41);
	
	var _glamorous = __webpack_require__(5);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _gatsbyLink = __webpack_require__(141);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _glamor = __webpack_require__(16);
	
	var _gatsbyImage = __webpack_require__(140);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactHelmet = __webpack_require__(59);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _components = __webpack_require__(12);
	
	var _style = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var ImageOverlay = _glamorous2.default.div.withConfig({
	  displayName: 'pages__ImageOverlay'
	})(_extends({}, _style.transition.slow('opacity', 'padding'), _style.padding.bottom(4), {
	  position: 'absolute',
	  top: 0,
	  bottom: 0,
	  left: 0,
	  right: 0,
	  backgroundImage: 'linear-gradient(to bottom, transparent 40%, rgba(0, 0, 0, 0.92) 100%)',
	  color: _style.colors.white,
	  display: 'flex',
	  flexDirection: 'column',
	  alignItems: 'center',
	  justifyContent: 'flex-end',
	  opacity: 0,
	  ':hover': _extends({
	    opacity: 1
	  }, _style.padding.bottom(5))
	}));
	
	var GalleryTitle = _glamorous2.default.h2.withConfig({
	  displayName: 'pages__GalleryTitle'
	})(_extends({}, _style.typography.title3, _style.typography.antialiased, _style.margin.bottom(2), {
	  fontWeight: 400
	}));
	
	var GalleryDetails = _glamorous2.default.p.withConfig({
	  displayName: 'pages__GalleryDetails'
	})(_extends({}, _style.typography.meta, _style.typography.antialiased, {
	  fontWeight: 400
	}));
	
	var blur = (0, _glamor.css)({
	  '> img[src^="data"]': {
	    filter: 'blur(5px)',
	    transform: 'scale(1.03)'
	  }
	});
	
	exports.default = function (_ref) {
	  var data = _ref.data,
	      history = _ref.history,
	      location = _ref.location;
	  var galleries = data.contentfulPage.galleries;
	  var search = location.search;
	
	  var categories = (0, _lodash.sortedUniq)((0, _lodash.sortBy)((0, _lodash.map)(galleries, function (gallery) {
	    return gallery.category.title;
	  })));
	  var siteUrl = data.site.siteMetadata.siteUrl;
	
	  return React.createElement(
	    React.Fragment,
	    null,
	    React.createElement(
	      _reactHelmet2.default,
	      null,
	      React.createElement('link', { rel: 'canonical', href: siteUrl })
	    ),
	    React.createElement(
	      _components.Wrapper,
	      null,
	      React.createElement(
	        _components.Filter,
	        {
	          filters: categories,
	          initialFilter: search.substring(1).length ? search.substring(1) : undefined,
	          history: history
	        },
	        function (filter) {
	          return React.createElement(
	            _components.Grid,
	            { filter: filter },
	            galleries.map(function (_ref2) {
	              var id = _ref2.id,
	                  slug = _ref2.slug,
	                  featuredImage = _ref2.featuredImage,
	                  title = _ref2.title,
	                  category = _ref2.category,
	                  images = _ref2.images;
	              var _featuredImage$file = featuredImage.file,
	                  url = _featuredImage$file.url,
	                  contentType = _featuredImage$file.contentType;
	
	              return React.createElement(
	                _components.Grid.Item,
	                {
	                  key: id,
	                  filterTag: category.title.toLowerCase()
	                },
	                React.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    to: {
	                      pathname: '/gallery/' + slug,
	                      state: { filter: filter }
	                    },
	                    style: { position: 'relative', display: 'block' }
	                  },
	                  /image/.test(contentType) ? React.createElement(_gatsbyImage2.default, {
	                    sizes: featuredImage.sizes,
	                    alt: featuredImage.title,
	                    className: blur
	                  }) : React.createElement(_components.Gif, {
	                    src: url,
	                    contentType: contentType,
	                    aspectRatio: featuredImage.fields && featuredImage.fields.aspectRatio
	                  }),
	                  React.createElement(
	                    ImageOverlay,
	                    null,
	                    React.createElement(
	                      GalleryTitle,
	                      null,
	                      title
	                    ),
	                    React.createElement(
	                      GalleryDetails,
	                      null,
	                      category.title + ' | ' + images.length + ' images'
	                    )
	                  )
	                )
	              );
	            })
	          );
	        }
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-92de35fbdd6e8c44c28d.js